/** Hours arithmetic for the diary, pure and tested. Everything is stored in minutes. */
export const HOUR_STEPS = Array.from({ length: 33 }, (_, i) => i * 30) // 0 .. 16h in half hours

export function formatMinutes(minutes: number): string {
  const m = Math.max(0, Math.round(minutes))
  const h = Math.floor(m / 60)
  const r = m % 60
  if (h === 0) return `${r}m`
  return r === 0 ? `${h}h` : `${h}h ${r}m`
}

export function planNumbers(availableMinutes: number, outcomeMinutes: number[]) {
  const allocated = outcomeMinutes.reduce((n, m) => n + Math.max(0, m), 0)
  return {
    allocated,
    buffer: Math.max(0, availableMinutes - allocated),
    overBy: Math.max(0, allocated - availableMinutes),
    /** Share of the day given to outcomes, 0..1 (capped). */
    share: availableMinutes > 0 ? Math.min(1, allocated / availableMinutes) : 0,
  }
}

/** How much of the planned outcome time was actually logged: null when nothing was planned. */
export function followThrough(plannedMinutes: number, loggedMinutes: number): number | null {
  if (plannedMinutes <= 0) return null
  return Math.round((loggedMinutes / plannedMinutes) * 100)
}

export const HAPPINESS = [
  { value: 1, emoji: '😣', label: 'Rough' },
  { value: 2, emoji: '😕', label: 'Meh' },
  { value: 3, emoji: '🙂', label: 'Okay' },
  { value: 4, emoji: '😄', label: 'Good' },
  { value: 5, emoji: '🤩', label: 'Great' },
] as const
